import { render } from "./DropUserComponent.vue?vue&type=template&id=35faa0ae"
import script from "./DropUserComponent.vue?vue&type=script&lang=js"
export * from "./DropUserComponent.vue?vue&type=script&lang=js"

import "./DropUserComponent.vue?vue&type=style&index=0&id=35faa0ae&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__